
<fury-page-layout mode="card">
  <fury-page-layout-header>
    <div class="top_heading">
      <fury-breadcrumbs [@fadeInRight] current="Add Agreement"></fury-breadcrumbs>
        <button mat-button class="can-button" (click)="redirectToDashboard()">
          <mat-icon>keyboard_backspace</mat-icon>
          Back
        </button>
    </div>
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div class="two_section">
      <div class="customer_leftinfo">
        <fury-customer-side-menu ></fury-customer-side-menu>
      </div>
      <div class="righpanel">

        <div class="two_selectpanel">
          <div class="select_radio">
            <div class="lead_box">
              <input type="radio" name="lead" [value]="leadInputEnum.createLead"  [(ngModel)]="selectedLeadOpetion"/>
              <img src="assets/img/create-lead.png"/>
              <div class="background"></div>
            </div>
             Create Lead 
          </div>
          <div class="select_radio">
            <div class="lead_box">
              <input type="radio" name="lead" [value]="leadInputEnum.selectLead"  [(ngModel)]="selectedLeadOpetion"/>
              <img src="assets/img/select-lead.png"/>
              <div class="background"></div>
            </div>
            Available Leads 
          </div>
        </div>
        <div class="table" *ngIf="selectedLeadOpetion === leadInputEnum.selectLead">
          <fury-leads-table
          [displayedColumns]="displayedColumns"
          [dataSource]="dataSource"
        ></fury-leads-table>
        <mat-paginator
        *ngIf="this.totalCount > 0"
        [pageSizeOptions]="[30, 50, 100, 9999]"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig]="selectConfig"
        [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
        </div>

        <div [@fadeInUp] [style.display]="selectedLeadOpetion === leadInputEnum.createLead ? 'block' : 'none'">
          <ng-container>
            <form [formGroup]="leadForm">
              <div class="field_area content" fxLayout="column" fxLayoutGap="8px">
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matInput placeholder="First Name" formControlName="first_name" (keyup)="apiService.restrictSpace($event)" (keypress)="apiService.restrictSpecialChar($event)">
                    <mat-error *ngIf="leadForm.controls['first_name'].touched && leadForm.controls['first_name'].hasError('required')">
                      This is required
                    </mat-error>
                    <mat-error *ngIf="leadForm.controls['first_name'].touched && leadForm.controls['first_name'].hasError('minlength')">
                       Please enter a valid first name.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput placeholder="Last Name"
                    formControlName="last_name"
                    (keyup)="apiService.restrictSpace($event)"
                    (keypress)="apiService.restrictSpecialChar($event)">
                    <mat-error *ngIf="leadForm.controls['last_name'].touched && leadForm.controls['last_name'].hasError('required')">
                       This is required
                     </mat-error>
                     <mat-error *ngIf="leadForm.controls['last_name'].touched && leadForm.controls['last_name'].hasError('minlength')">
                      Please enter a valid last name.
                     </mat-error>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matInput placeholder="Phone Number"
                    formControlName="phone"
                    mask="(000) 000-0000">
                    <mat-error *ngIf="
                    leadForm.controls['phone'].touched &&
                    leadForm.controls['phone'].hasError('required')">
                      
                        This is required
                      </mat-error>
                      <mat-error *ngIf="leadForm.controls['phone'].hasError('notValid')">
                       Please enter an active phone number
                       </mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Email Address</mat-label>
                    <input matInput placeholder="Email Address"
                    formControlName="email"
                    (keyup)="changeEmailAndSet()">
                    <mat-error *ngIf="
                    leadForm.controls['email'].touched &&
                    leadForm.controls['email'].hasError('required')">
                      
                        This is required
                     </mat-error>
                     <mat-error *ngIf="
                     leadForm.controls['email'].value !== '' &&
                     leadForm.controls['email'].hasError('pattern')">
                      
                        Email is not valid
                      </mat-error>
                      <mat-error *ngIf="leadForm.controls['email'].hasError('notValid')">
                        Please enter an active email address
                      </mat-error>
                  </mat-form-field>
                </div>
        
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <span [ngClass]="!showZipcodeField ? 'fullwidth' : 'halfwidth'">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Home Address</mat-label>
                      <input matInput placeholder="Home Address"
                      formControlName="address"
                      #benotifyCoverdformaddress>
                      <mat-error *ngIf="
                      leadForm.controls['address'].touched &&
                      leadForm.controls['address'].hasError('required')">
                        This is required
                      </mat-error>
                      <mat-error *ngIf="leadForm.controls['address'].hasError('notValid')">
                        Unfortunately, we do not cover the state of {{leadForm.value?.state}}.
                      </mat-error>
                      
                    </mat-form-field>
                  </span>
                  <span [ngClass]="!showZipcodeField ? 'unitwidth' : 'twothirdwidth'">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Enter Unit Number</mat-label>
                      <input matInput placeholder="Enter Unit Number"
                      formControlName="unitNumber">
                     </mat-form-field>
                  </span>
                  <span [ngClass]="!showZipcodeField ? 'fullwidth' : 'onethirdwidth'" *ngIf="showZipcodeField">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Zip Code</mat-label>
                      <input matInput placeholder="Zip Code"
                      formControlName="zip"
                      mask="00000"
                      (keyup)="zip($event)">
                      <mat-error *ngIf="
                      leadForm.controls['zip'].touched &&
                      leadForm.controls['zip'].hasError('required')">
                          This is required
                      </mat-error>
                      <mat-error *ngIf="leadForm.controls['zip'].hasError('notValid')">
                        Please enter an accurate zip code.
                      </mat-error>
                    </mat-form-field>
                  </span>
                </div>
                <!-- <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                 
                </div> -->
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Select property type</mat-label>
                    <mat-select formControlName="planTypeId" (selectionChange)="propertyTypeChange($event)">
                      <mat-option *ngFor="let item of propertyType" [value]="item?.planPropertyTypeId">{{item?.title}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="leadForm.controls['planTypeId'].touched && leadForm.controls['planTypeId'].hasError('required')">
                        This is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Select property size</mat-label>
                    <mat-select formControlName="planSizeId">
                      <mat-option *ngFor="let item of propertySize" [value]="item?.planPropertySizeId">{{item?.title}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="leadForm.controls['planSizeId'].touched && leadForm.controls['planSizeId'].hasError('required')">
                        This is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
                  <button mat-button type="button" class="sub-button" (click)="submitQuote()" *ngIf="!leadForm.controls['email'].hasError('loading')">
                    Genarate Lead
                  </button>
                  <img
                  *ngIf="leadForm.controls['email'].hasError('loading')"
                  [ngSrc]="assetsUrl + 'loder.gif'"
                  alt="loader" width="150" height="30"
                />
                  <!-- <button class="can-button" type="button" (click)="redirectToDashboard()" mat-button>Cancel</button> -->
                </div>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
    </div>
  </fury-page-layout-content>
  

  
</fury-page-layout>





